import { useEffect, useRef } from "react";
import { MapPin } from "lucide-react";
export default function ServiceTrustBadges() {
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const items = entry.target.querySelectorAll(".trust-item");
          items.forEach((item, i) => {
            setTimeout(() => {
              (item as HTMLElement).style.opacity = "1";
              (item as HTMLElement).style.transform = "translateY(0)";
            }, i * 120);
          });
        }
      });
    }, {
      threshold: 0.2
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const badges = [{
    label: "Fully Insured Work",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M9 12l2 2 4-4" />
        </svg>,
    accent: "#4f46e5"
  }, {
    label: "Free Consultation",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z" />
        </svg>,
    accent: "#0ea5e9"
  }, {
    label: "Quality Guaranteed",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
          <rect x="2" y="5" width="20" height="14" rx="2" />
          <path d="M12 12m-3 0a3 3 0 106 0 3 3 0 10-6 0" />
          <path d="M2 10h3M19 10h3M2 14h3M19 14h3" />
        </svg>,
    accent: "#10b981"
  }, {
    label: "Local South London Team",
    icon: <MapPin className="w-7 h-7" />,
    accent: "#f59e0b"
  }];
  return <section ref={sectionRef} className="relative bg-background overflow-hidden py-14 px-4">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=Inter:wght@400;500&display=swap');`}</style>

      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full opacity-[0.04] bg-indigo-500 blur-3xl" />
        <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full opacity-[0.04] bg-sky-500 blur-3xl" />
      </div>

      <div className="relative max-w-5xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border rounded-2xl overflow-hidden shadow-sm">
          {badges.map((badge, i) => <div key={badge.label} className="trust-item group bg-card hover:bg-muted transition-all duration-300 cursor-default" style={{
          opacity: 0,
          transform: "translateY(18px)",
          transition: "opacity 0.5s ease, transform 0.5s ease, background-color 0.3s ease"
        }}>
              <div className="flex flex-col items-start gap-4 p-7 h-full relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
              background: badge.accent
            }} />

                <div className="flex items-center justify-center w-12 h-12 rounded-xl transition-transform duration-300 group-hover:scale-110" style={{
              background: `${badge.accent}14`,
              color: badge.accent
            }}>
                  {badge.icon}
                </div>

                <div className="flex flex-col gap-1.5">
                  <span className="text-[10px] font-medium tracking-widest uppercase" style={{
                color: badge.accent,
                fontFamily: "'Inter', sans-serif"
              }}>
                    0{i + 1}
                  </span>
                  <p className="text-foreground leading-snug text-base" style={{
                fontFamily: "'Syne', sans-serif",
                fontWeight: 700,
                letterSpacing: "-0.01em"
              }}>
                    {badge.label}
                  </p>
                </div>

                <div className="mt-auto w-6 h-0.5 rounded-full opacity-40 group-hover:w-10 group-hover:opacity-100 transition-all duration-300" style={{
              background: badge.accent
            }} />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}